import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import i18n from '../utils/i18n';

import './styles/AttendeeComponent.scss';

const AttendeeComponent = ({
  openEmergencyContactModal,
  toggleAttendeePresent,
  disabled,
  userId,
  firstName,
  lastName,
  present,
  bookingId,
  datetime,
  showPresenceInfo
}) => (
  <tr>
    <td>
      {firstName} {lastName}
    </td>
    <td>{dateFormat(datetime, 'dd.mm.yyyy h:MM TT')}</td>
    {showPresenceInfo && (
      <td>
        <div className="presence-container">
          <div key="present">
            <input
              type="radio"
              name={ `present-${bookingId}` }
              value=""
              checked={ present === true }
              onChange={ () => toggleAttendeePresent(bookingId, true) }
              disabled={ disabled }
            />
            <div className="presence-option-label">
              {i18n.t('attendeesList.PRESENT')}
            </div>
          </div>
          <div key="absent">
            <input
              type="radio"
              name={ `present-${bookingId}` }
              value=""
              checked={ present === false }
              onChange={ () => toggleAttendeePresent(bookingId, false) }
              disabled={ disabled }
            />
            <div className="presence-option-label">
              {i18n.t('attendeesList.ABSENT')}
            </div>
          </div>
        </div>
      </td>
    )}
    <td className="text-center">
      <button
        className="btn btn-danger"
        onClick={ () => {
          openEmergencyContactModal(userId);
        } }
      >
        {i18n.t('attendeesList.VIEW_EMERGENCY_CONTACT_BUTTON')}
      </button>
    </td>
  </tr>
);

AttendeeComponent.propTypes = {
  openEmergencyContactModal: PropTypes.func.isRequired,
  toggleAttendeePresent: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  present: PropTypes.bool.isRequired,
  bookingId: PropTypes.number.isRequired,
  datetime: PropTypes.string.isRequired,
  showPresenceInfo: PropTypes.bool.isRequired
};

export default AttendeeComponent;



// WEBPACK FOOTER //
// ./src/components/AttendeeComponent.js